const listeners = new Set<() => void>();
let workspaceRoleGeneration = 0;
const roleListeners = new Set<() => void>();

export function notifyNonCsrfForbidden(): void {
  for (const listener of listeners) listener();
}

export function subscribeAccessDenied(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function requestWorkspaceRoleRefresh(): void {
  workspaceRoleGeneration += 1;
  for (const listener of roleListeners) listener();
}

export function subscribeWorkspaceRoleRefresh(listener: () => void): () => void {
  roleListeners.add(listener);
  return () => roleListeners.delete(listener);
}

export function getWorkspaceRoleRefreshGeneration(): number {
  return workspaceRoleGeneration;
}

export function isCsrfForbidden(code: string | undefined, message: string | undefined): boolean {
  return (
    code === 'CSRF_TOKEN_MISSING' ||
    code === 'CSRF_TOKEN_MISMATCH' ||
    code === 'CSRF_TOKEN_INVALID' ||
    /csrf/i.test(String(message || ''))
  );
}
